// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9357":"1bd95b5a858d1212","95868":"6438dbb375600f1b","98708":"d47e4f3ff15ec2c4"}[chunkId] + ".css";
};